import React, { useState } from 'react';
import logoImage from '../../img/logo.png';
import mobilePicture from '../../img/bg.png';
import trophyPicture from '../../img/cube.png';
import chatPicture from '../../img/chat.png';
import 'react-phone-number-input/style.css';
import PhoneInput from 'react-phone-number-input';
import './Header.scss';
// import ParallaxImagesContainer from './Paralax';

function Header() {
  const [value, setValue] = useState();
  return (
    <>
      <header className="header">
        <a href="#" className="logo">
          <img src={logoImage} alt="Jusan Invest" width="126px" />
        </a>
        <div class="herobanner">
          <div className="herobanner-container">
            <div className="herobanner-left">
              <h1 className="heading-1">
                Научите детей <br /> управлять деньгами
              </h1>
              <p className="hero-banner-text">
                Помогите детям выработать полезные <br /> денежные привычки
              </p>
              <p className="sub-text">
                Получите сообщение в What’sApp со ссылкой на приложение
              </p>
              <div className="form-telephone">
                <PhoneInput
                  className="form-telephone-input"
                  placeholder="Ваш телефон номера"
                  value={value}
                  onChange={setValue}
                />
                <button class="form-telephone-btn">Отправить ссылку</button>
              </div>
            </div>
            <div className="herobanner-right">
              <img
                className="herobanner-picture1"
                data-speed="5"
                src={mobilePicture}
                alt="trophy"
              />

              <img
                className="herobanner-picture2"
                data-speed="6"
                src={trophyPicture}
                alt="chat"
              />

              <img
                className="herobanner-picture3"
                src={chatPicture}
                alt="trophy"
              />
              {/* <ParallaxImagesContainer /> */}
            </div>
          </div>
        </div>
      </header>
    </>
  );
}

export default Header;
